import React, { useEffect } from 'react';
import Page from '../../components/layout/Page';
import ExternalLink from '../../components/ExternalLink';
import './index.css';

const RESERVE_URL = 'https://luma.com/3nk3dlf7';

const _style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const IDHPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page title="International Day of Happiness 2026" className="landing-page" style={_style}>
      <div className="container text-center" style={{ maxWidth: '42em', marginTop: '2em', marginBottom: '3em' }}>
        <div style={{ marginBottom: '2em' }}>
          <img alt="HNP logo" src="/images/hnp-logo-192.png" style={{ height: '5em' }} />
        </div>

        <h1 style={{ color: 'rgb(87, 85, 217)', marginBottom: '0.5em' }}>
          🌍 Celebrate the International Day of Happiness With Us! 😊
        </h1>

        <blockquote
          style={{
            margin: '1.5em 0',
            paddingLeft: '1.25em',
            borderLeft: '4px solid rgb(87, 85, 217)',
            fontStyle: 'italic',
            fontSize: '1.2em',
            lineHeight: 1.6,
            color: '#333',
          }}
        >
          <p style={{ margin: 0, marginBottom: '0.5em' }}>
            "Happiness is more than a feeling; it's a force that connects people, inspires purpose, and fuels success."
          </p>
          <cite style={{ fontStyle: 'normal', fontSize: '0.9em', color: '#555' }}>
            — Edwin Edebiri, Global Chief Happiness Officer
          </cite>
        </blockquote>

        <p style={{ fontSize: '1.15em', lineHeight: 1.6, marginBottom: '1.5em' }}>
          On March 20th, join an uplifting global gathering as we celebrate the International Day of Happiness with powerful conversations, meaningful connections, and positive energy.
        </p>

        <div style={{ backgroundColor: 'rgb(255, 250, 240)', padding: '1.5em', borderRadius: '0.5em', marginBottom: '1.5em' }}>
          <p style={{ margin: 0, fontSize: '1.1em' }}>🗓 <strong>March 20th</strong></p>
          <p style={{ margin: '0.5em 0 0', fontSize: '1.1em' }}>⏰ 11 AM PST | 1 PM CST | 2 PM EST</p>
        </div>

        <p style={{ fontSize: '1.15em', lineHeight: 1.6, marginBottom: '1.5em' }}>
          This is your opportunity to pause, connect with inspiring people, and celebrate the power of happiness in our lives and businesses.
        </p>

        <p style={{ fontSize: '1.1em', marginBottom: '0.5em' }}>👉 Reserve your spot here:</p>
        <div style={{ marginBottom: '2em' }}>
          <ExternalLink href={RESERVE_URL} className="btn btn-lg" target="_blank" rel="noopener noreferrer">
            Reserve on Luma
          </ExternalLink>
        </div>
        <p style={{ fontSize: '0.95em', color: '#555', marginBottom: '1em' }}>
          <a href={RESERVE_URL} target="_blank" rel="noopener noreferrer">{RESERVE_URL}</a>
        </p>

        <p style={{ fontSize: '1.15em', lineHeight: 1.6 }}>
          Come celebrate, connect, and spread happiness with us. The world needs more of it! 🌟
        </p>
      </div>
    </Page>
  );
};

export default IDHPage;
